import React from "react";
import TextMedium from "../TextComponent/TextMedium";
import { ResponsivePie } from "@nivo/pie";
import { ReactComponent as LoadingAnswer } from "../../../build/images/loadingmanageranswer.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanager.svg";
import { ReactComponent as PhoneIcon } from "../../../build/images/icontell.svg";
import { ReactComponent as TimeIcon } from "../../../build/images/icontime.svg";
import { ReactComponent as UserRemoveIcon } from "../../../build/images/userremove.svg";
import { ReactComponent as UserPhoneIcon } from "../../../build/images/user-phone-icon.svg";
import { useSelector } from "react-redux";

export default function CardClientAnswer({
  title,
  level,
  desempenhoRec,
  timeAverageMidleAnswer,
  timeAverageQtdAbandoned,
  atendidas,
  classname = "",
}) {
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);

  let data = [];

  if (level === 100) {
    data = [
      {
        id: "erlang",
        label: "erlang",
        value: level,
        color: "#00ACC1",
      },
    ];
  } else {
    data = [
      {
        id: "erlang",
        label: "erlang",
        value: level,
        color: "#00ACC1",
      },
      {
        id: "go",
        label: "go",
        value: 100 - level,
        color: "#FFFFFF",
      },
    ];
  }

  return (
    <div className={`manager-component__card-client-answer ${classname}`}>
      <div className="manager-component__card-client-answer__title">
        <TextMedium text={title} color="gray" />
      </div>
      <div className="manager-component__card-client-answer__box">
        <div className="manager-component__card-client-answer__box-chart">
          {LoginCompleteReducer.isLoginComplete ? (
            <>
              {level > 0 ? (
                <>
                  <ResponsivePie
                    data={data}
                    margin={{ top: 0, right: 5, bottom: 0, left: 5 }}
                    startAngle={0}
                    innerRadius={0.85}
                    cornerRadius={12}
                    fit={false}
                    activeOuterRadiusOffset={8}
                    borderWidth={1}
                    isInteractive={false}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", 0.2]],
                    }}
                    enableArcLinkLabels={false}
                    enableArcLabels={false}
                    colors={{ datum: "data.color" }}
                  />
                  <div className="manager-component__card-client-answer__root-overlay">
                    <strong>{level}%</strong>
                    <span>Atendidas</span>
                  </div>
                </>
              ) : (
                <div className="empty-state__client-answer">
                  <EmptyState />
                </div>
              )}
            </>
          ) : (
            <div className="loading__client-answer">
              <svg
                width="259"
                height="120"
                viewBox="0 0 259 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="159"
                  y="86"
                  width="100"
                  height="16"
                  rx="8"
                  fill="black"
                  fill-opacity="0.1"
                />
                <rect
                  x="159"
                  y="42"
                  width="100"
                  height="38"
                  rx="19"
                  fill="black"
                  fill-opacity="0.1"
                />
                <rect
                  x="23"
                  y="42"
                  width="74"
                  height="38"
                  rx="19"
                  fill="black"
                  fill-opacity="0.1"
                />
                <path
                  d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM9 60C9 88.1665 31.8335 111 60 111C88.1665 111 111 88.1665 111 60C111 31.8335 88.1665 9 60 9C31.8335 9 9 31.8335 9 60Z"
                  fill="black"
                  fill-opacity="0.1"
                />
                <path
                  d="M60 4.5C60 2.01472 62.0176 -0.0175617 64.4959 0.168645C74.7793 0.941287 84.7177 4.35446 93.3342 10.1118C103.201 16.7047 110.892 26.0754 115.433 37.039C119.974 48.0026 121.162 60.0666 118.847 71.7055C116.532 83.3443 110.818 94.0353 102.426 102.426C94.0352 110.818 83.3442 116.532 71.7053 118.847C60.0665 121.162 48.0025 119.974 37.0389 115.433C26.0753 110.891 16.7046 103.201 10.1118 93.3341C4.35442 84.7176 0.941258 74.7792 0.168636 64.4958C-0.0175657 62.0175 2.01472 59.9999 4.5 59.9999C6.98528 59.9999 8.97938 62.0186 9.19837 64.4942C9.95039 72.9954 12.8269 81.1981 17.595 88.334C23.1989 96.7209 31.164 103.258 40.4831 107.118C49.8021 110.978 60.0565 111.988 69.9495 110.02C79.8426 108.052 88.9299 103.195 96.0624 96.0625C103.195 88.93 108.052 79.8427 110.02 69.9496C111.988 60.0566 110.978 49.8022 107.118 40.4832C103.258 31.1641 96.721 23.199 88.3341 17.5951C81.1982 12.827 72.9955 9.95042 64.4943 9.19838C62.0187 8.97938 60 6.98528 60 4.5Z"
                  fill="#757575"
                />
              </svg>
            </div>
          )}
        </div>
        {level > 0 && LoginCompleteReducer.isLoginComplete && (
          // <div>
          //     <div className="manager-component__card-client-answer__box-chart_container-text">
          //         <div className="manager-component__card-client-answer__box-chart_container-text-icon">
          //             <PhoneIcon />
          //             <strong>{desempenhoAtd}</strong>
          //         </div>
          //         <span>Ligações recebidas</span>
          //     </div>
          //     <div className="manager-component__card-client-answer__box-chart_container-text">
          //         <div className="manager-component__card-client-answer__box-chart_container-text-icon">
          //             <TimeIcon />
          //             <strong>{'08:00'}</strong>
          //         </div>
          //         <span>Tempo Médio de Atendimento</span>
          //     </div>
          // </div>
          <div className="manager-component__card-queue__box-contents">
            <div className="manager-component__card-queue__box-contents__itens">
              <div className="manager-component__card-queue__box-contents__itens-icon">
                <PhoneIcon />
              </div>
              <div className="manager-component__card-queue__box-contents__itens-text">
                <h3>{desempenhoRec}</h3>
                <span>Qtd. interações</span>
              </div>
            </div>
            <div className="manager-component__card-queue__box-contents__itens">
              <div className="manager-component__card-queue__box-contents__itens-icon">
                <UserPhoneIcon />
              </div>
              <div className="manager-component__card-queue__box-contents__itens-text">
                <h3>{atendidas}</h3>
                <span>Qtd. atendidas</span>
              </div>
            </div>
            <div className="manager-component__card-queue__box-contents__itens">
              <div className="manager-component__card-queue__box-contents__itens-icon">
                <UserRemoveIcon />
              </div>
              <div className="manager-component__card-queue__box-contents__itens-text">
                <h3>{timeAverageQtdAbandoned}</h3>
                <span>Qtd. Abandonos</span>
              </div>
            </div>
            <div className="manager-component__card-queue__box-contents__itens">
              <div className="manager-component__card-queue__box-contents__itens-icon">
                <TimeIcon />
              </div>
              <div className="manager-component__card-queue__box-contents__itens-text">
                <h3>{timeAverageMidleAnswer}</h3>
                <span>T.M.A.</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
